import { baseApi, standardQueryTableRequest } from "api/baseApi";
import { IQueryParams } from "api/requestModels";
import { ITokenizeByLinkModel } from "./tokenizeByLinkModels";
import { ITokenizeByLinkTokensModel } from "./tokenizeByLinkTokensModels";

export const baseTokenizeByLinkRoute = "/api/tokenizeByLink";
export const tokenizeByLinkExportRoute = `${baseTokenizeByLinkRoute}/tokens-report`;

const tokenizeByLinkApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getTokenizeByLink: builder.query<ITokenizeByLinkModel, IQueryParams>({
            query: standardQueryTableRequest<ITokenizeByLinkModel>(baseTokenizeByLinkRoute),
        }),
        getTokenizeByLinkTokens: builder.query<ITokenizeByLinkTokensModel, IQueryParams>({
            query: standardQueryTableRequest<ITokenizeByLinkTokensModel>(`${baseTokenizeByLinkRoute}/tokens`),
        }),
    }),
    overrideExisting: false,
});

export const { endpoints } = tokenizeByLinkApi;
